import React from "react";
import NoSearchitems from "./NoSearchitems";

const OdActivity = ({ data }) => {
  function truncateText(text, maxLength = 40) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    } else {
      return text;
    }
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  return (
    <div className="pt-3">
      <div className="flex justify-between items-center">
        <p className=" text-sm font-semibold">OD Activity</p>
      </div>
      <div className="rounded-lg border border-[#E6EBED] mt-4 overflow-auto">
        <table className="w-full min-w-[1160px] box-border flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold">
            <tr className="w-full flex items-center">
              <th className="text-left pl-6 pt-1 pb-3 w-[17%]">Date</th>
              <th className={`text-left w-[20%]`}>Transaction Description</th>

              <th className="text-left w-[16%] pl-14">Debit</th>
              <th className={`text-left w-[16%] pl-14`}>Credit </th>
              <th className={`text-left w-[16%] pl-16`}>Overdraft Limit</th>

              <th className={`text-left w-[20%] pl-16`}>
                Principal Outstanding
              </th>
            </tr>
          </thead>

          <tbody className={`   ${data?.length === 0 ? " " : ""}`}>
            {data?.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}
            {data?.map((item, index) => (
              <tr
                className={`text-xs font-medium w-full flex items-center h-[43px] ${
                  index % 2 === 0 ? "bg-[#f8f8f8]" : "bg-white"
                }`}
              >
                <td className="text-left pl-6 w-[16%]">{item.date || "--"}</td>
                <td
                  className={`text-left w-[20%] pt-3 pb-2`}
                  title={item.transaction_description}
                >
                  {truncateText(item.transaction_description, 57) || "--"}
                </td>
                <td className="text-left w-[16%] pl-10 text-[#D30D00]">
                  {" "}
                  {item.debit ? formatToIndianRupees(item.debit) : ""}
                </td>
                <td className={`text-left w-[16%] pl-9 text-[#47B971]`}>
                  {item.credit ? formatToIndianRupees(item.credit) : ""}
                </td>
                <td className={`text-left w-[16%] pl-9`}>
                  {formatToIndianRupees(item.od_limit) || "--"}
                </td>

                <td className={`text-left w-[16%] pl-7`}>
                  {formatToIndianRupees(item.principal_outstanding) || "--"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OdActivity;
